import { Button, Popconfirm, Tag, message } from 'antd'
import BigNumber from 'bignumber.js'
import React from 'react'
import { COLORS } from '../../../constants'
import { TagWrap } from './styles'
import { column_order } from './column_order'
import UserTag from '../../UserTag'
import { Text } from '../../../../styles/reactnative'
import PnlPrice from '../../PositionColumns/PnlPrice'
import Price from '../../PositionColumns/Price'
import API from '../../../../utils/api'
import MarkPrice from '../../PositionColumns/MarkPrice'
import Avatar from 'antd/es/avatar/avatar'
import {
	CheckOutlined,
	InfoCircleOutlined,
	StopOutlined,
	TeamOutlined,
} from '@ant-design/icons'
import PopUpConfirmation from '../../../organisms/Trade/TradeNavBar/TradeSettingPreference/PreferenceDrawerTrade/PreferenceGeneral/PopUpConfirmation'
import { cell_user } from '../Cell/user'
import ExchangeName from '../../ExchangeName'
import Contracts from '../../PositionColumns/Contracts'
import styled from 'styled-components'

const GroupTag = styled.span`
	display: inline-flex;
	align-items: center;
	padding: 2px 6px;
	background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
	color: white;
	border-radius: 4px;
	font-size: 10px;
	font-weight: 500;
	white-space: nowrap;
	height: 20px;
`

export const column_order_page = (mutate, setModal, token, fold) => {
	const columns = column_order(mutate, setModal, token, false)

	columns?.map((item: any, index) => {
		if (item?.key == 'status') {
			item.width = 120
			item.render = (text, record) => (
				<TagWrap
					style={{ justifyContent: 'center', flexDirection: 'row' }}>
					<Tag
						style={{
							display: 'flex',
							alignItems: 'center',
							color:
								record?.open_close == 'C'
									? COLORS.darkBlue
									: text == 2
									? COLORS.lightGreen
									: text == 1
									? COLORS.black
									: COLORS.lightRed,
						}}>
						{text == 2 ? (
							<CheckOutlined />
						) : text != 1 ? (
							<StopOutlined />
						) : null}
						{text == 1
							? '미체결'
							: text == 2
							? `${record?.open_close == 'O' ? '신규' : '종료'}`
							: '취소'}
					</Tag>
					{text == 1 && (
						// <Popconfirm
						// 	title="주문취소"
						// 	description="주문을 취소하시겠습니까?"
						// 	onConfirm={() => {
						// 		API.post('/admin/trade/cancel', token + '', {
						// 			orderid: record?.id,
						// 			userid: record?.user_id,
						// 		}).then(res => {
						// 			message.success('주문이 취소되었습니다.')
						// 			mutate()
						// 		})
						// 	}}>
							<Button
								size="small"
								type="primary"
								danger
								onClick={e => {

									API.post('/admin/trade/cancel', token + '', {
										orderid: record?.id,
										userid: record?.user_id,
									}).then(res => {
										message.success('주문이 취소되었습니다.')
										mutate()
									})
									
								}}
								style={{ marginTop: 5 }}>
								취소
							</Button>
						// </Popconfirm>
					)}
				</TagWrap>
			)
		}

		return item
	})

	return [
		{
			title: '시장',
			dataIndex: 'exchange_id',
			align: 'center',
			render: (text, record) => <ExchangeName exchange_id={text} />,
		},
		{
			title: '회원',
			dataIndex: 'user_id',
			key: 'user_id',
			align: 'center',
			width: 150,
			render: (text, data) => (
				<UserTag
					userid={text}
					email={data?.email}
					phone={data?.phone}
					nickname={data?.fullname || data?.nickname}
					level={data?.level}
					onClick={() => {
						setModal(text)
					}}
				/>
			),
		},
		{
			title: '그룹',
			align: 'center',
			dataIndex: 'referral_code',
			width: 100,
			render: (text, data) => (
				text ? (
					<GroupTag>
						<TeamOutlined style={{ fontSize: 10, marginRight: 2 }} />
						{text}
					</GroupTag>
				) : (
					<span style={{ color: '#999', fontSize: 11 }}>-</span>
				)
			),
		},
		...columns,
	]
}
